module.exports = __webpack_public_path__ + "media/images/hero_header/hero_header5-06c4a9a2fd850d2856a33379f6c85962.jpeg";